import { useMutation, useQueryClient } from 'react-query';

import {
  UpdateAiAlertSubscriptionParams,
  updateAiAlertSubscription,
} from '@utils/backend-api/aiAlertSubscriptions';

import { AI_ALERT_SUBSCRIPTIONS_KEY } from './useAiAlertSubscriptions';

export function useAiAlertSubscriptionUpdate({
  onSuccess,
  onError,
}: {
  onSuccess?: () => void;
  onError?: (error: Error) => void;
}) {
  const queryClient = useQueryClient();

  const { mutate, isLoading } = useMutation(
    (params: UpdateAiAlertSubscriptionParams) => updateAiAlertSubscription(params),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(AI_ALERT_SUBSCRIPTIONS_KEY);
        onSuccess?.();
      },
      onError: (error: Error) => {
        onError?.(error);
      },
    }
  );

  return {
    updateAiAlertSubscription: mutate,
    isUpdatingAiAlertSubscription: isLoading,
  };
}
